import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeComponentProps as _mergeComponentProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("styled-phone-number__phonectaphonestyles-11aefl", {
  color: "var(--primary-orange-500)",
  display: "flex",
  justifyContent: "flex-end",
  width: "100%",
  "& span": {
    lineHeight: 1
  }
});
import React from 'react';
import PhoneNumber from '../../primitives/phone-number';
import Typography from '../../primitives/typography';
import { colors } from '../../primitives/colors';
export const phoneCtaPhoneStyles = _staticStyles;
export const StyledPhoneDisplay = ({
  children
}: {
  children: string;
}): JSX.Element => <Typography {..._mergeComponentProps({
  fontSize: {
    dt: 'lg'
  },
  css: phoneCtaPhoneStyles,
  "aria-hidden": "true"
})}>
        <span>{children}</span>
    </Typography>;
const StyledPhoneNumber = ({
  children,
  dialNumber,
  ...props
}: React.PropsWithChildren<{
  dialNumber?: string | null;
}> & Omit<Omit<React.HTMLProps<HTMLDivElement>, 'color'>, 'as'>): JSX.Element => <Typography {..._mergeComponentProps({
  fontSize: {
    dt: 'lg'
  },
  css: phoneCtaPhoneStyles
}, props)}>
        <span>
            <PhoneNumber dialNumber={dialNumber}>{children as string}</PhoneNumber>
        </span>
    </Typography>;
export default StyledPhoneNumber;